// src/pages/Roadmap.js
import React from "react";
import { motion } from "framer-motion";

const roadmap = [
  {
    year: "2024",
    quarters: [
      {
        title: "Q4 2024: Laying the Groundwork (Completed)",
        items: [
          "Platform Architecture Design",
          "Website Development",
          "ICO Launch (MediCoin Offering)",
          "Basic Membership Authentication",
          "Profile Creation",
          "Event Registration Setup",
          "AI Training (Initiation)",
          "Partnership Outreach",
        ],
      },
    ],
  },
  {
    year: "2025",
    quarters: [
      {
        title: "Q1 2025: Development and Expansion (Completed)",
        items: [
          "Complete MVP Development",
          "Beta Testing",
          "Finalize Partnership Agreements",
        ],
      },
      {
        title: "Q2 2025: Platform Expansion (In Progress)",
        items: [
          "Onboard Providers and Members",
          "AI + IoMT Integration",
        ],
      },
      {
        title: "Q3 2025: AI and Data Analytics Rollout",
        items: [
          "Launch Full AI Capabilities",
          "Launch MCN Payments",
        ],
      },
      {
        title: "Q4 2025: Marketplace and Growth Initiatives",
        items: [
          "Launch MediCureOn Marketplace",
          "Begin Global Expansion",
        ],
      },
    ],
  },
  {
    year: "2026",
    quarters: [
      {
        title: "Q1 2026: Onboarding and Integration",
        items: [
          "Onboard Key Healthcare Entities",
          "Integrate Payers & Pharmaceuticals",
          "Partner with Research Institutes",
        ],
      },
      {
        title: "Q2 2026: AI and IoMT Phase 1",
        items: [
          "Launch Real-Time Monitoring",
          "Partner with IoMT Manufacturers",
        ],
      },
      {
        title: "Q3 2026: International Expansion",
        items: [
          "Expand into Underserved Regions",
          "Ensure Regional Compliance",
        ],
      },
      {
        title: "Q4 2026: AI & Automation",
        items: [
          "Advance Predictive Analytics",
          "Introduce Smart Contracts",
        ],
      },
    ],
  },
  {
    year: "2027",
    quarters: [
      {
        title: "Q1 2027: Global Rollout",
        items: [
          "Full Global Launch",
          "Drive Member Adoption",
        ],
      },
      {
        title: "Q2 2027: Telemedicine + Decentralization",
        items: [
          "Launch Telemedicine",
          "Rollout Decentralized Health Management",
        ],
      },
      {
        title: "Q3 2027: Blockchain & DeFi",
        items: [
          "Launch Private Medical Blockchain",
          "Develop Healthcare Financial Services",
        ],
      },
      {
        title: "Q4 2027: Self-Sustaining Ecosystem",
        items: [
          "Launch Final Marketplace",
          "Enable Fully Personalized Care Plans",
          "Establish Ecosystem Using MCN",
        ],
      },
    ],
  },
];

export default function RoadmapPage() {
  return (
    <div className="max-w-5xl mx-auto px-6 py-12 text-white">
      <h1 className="text-4xl md:text-5xl font-bold text-center mb-14 bg-gradient-to-r from-purple-400 via-pink-400 to-indigo-400 bg-clip-text text-transparent">
        🛣️ MediCureOn Roadmap
      </h1>

      <div className="border-l-4 border-purple-600 pl-6 space-y-12">
        {roadmap.map((yearObj, i) => (
          <div key={i}>
            <motion.h2
              className="text-3xl font-bold text-purple-400 mb-6"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7 }}
            >
              {yearObj.year}
            </motion.h2>

            {yearObj.quarters.map((quarter, j) => (
              <motion.div
                key={j}
                initial={{ opacity: 0, y: 50, scale: 0.95 }}
                whileInView={{ opacity: 1, y: 0, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: j * 0.2 }}
                className="mb-10 bg-[#1f1b3a]/70 backdrop-blur-md p-6 rounded-xl shadow-xl hover:shadow-purple-500/30 transition-transform hover:scale-105"
              >
                <h3 className="text-2xl font-semibold text-white mb-4">{quarter.title}</h3>
                <ul className="list-disc list-inside text-gray-300 space-y-2 text-sm">
                  {quarter.items.map((item, k) => (
                    <li key={k}>✅ {item}</li>
                  ))}
                </ul>
              </motion.div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
